export enum AbilityTreeKey {
  alchemy = 'alchemy',
  armor_use = 'armor_use',
  bow_use = 'bow_use',
  conjuration = 'conjuration',
  illusion = 'illusion',
  melee_combat = 'melee_combat',
  movement = 'movement',
  spirit = 'spirit',
}
export type AbilityTreeKeyType = `${AbilityTreeKey}`;

export enum BattleTeam {
  white = 'white',
  black = 'black',
}
export type BattleTeamType = `${BattleTeam}`;

export enum CandleAlignment {
  balance = 'balance',
  chaos = 'chaos',
  order = 'order',
}
export type CandleAlignmentType = `${CandleAlignment}`;

export enum CavernsDirection {
  NORTH = 'NORTH',
  SOUTH = 'SOUTH',
  EAST = 'EAST',
  WEST = 'WEST',
  UP = 'UP',
  DOWN = 'DOWN',
}
export type CavernsDirectionType = `${CavernsDirection}`;

export enum CavernsSubmodeKey {
  GAME_SUBMODE_caverns1man = 'GAME_SUBMODE_caverns1man',
  GAME_SUBMODE_caverns2man = 'GAME_SUBMODE_caverns2man',
  GAME_SUBMODE_caverns3man = 'GAME_SUBMODE_caverns3man',
  GAME_SUBMODE_caverns5man = 'GAME_SUBMODE_caverns5man',
  GAME_SUBMODE_caverns7man = 'GAME_SUBMODE_caverns7man',
  GAME_SUBMODE_caverns11man = 'GAME_SUBMODE_caverns11man',
}
export type CavernsSubmodeKeyType = `${CavernsSubmodeKey}`;

export enum GameItemSlot {
  boots = 'boots',
  helmet = 'helmet',
  off_hand = 'off_hand',
  torsoe = 'torsoe',
  weapon = 'weapon',
  ring = 'ring',
  item_container = 'item_container',
}
export type GameItemSlotType = `${GameItemSlot}`;

export enum GameItemType {
  equipment_dye = 'equipment_dye',
  prayer_candle = 'prayer_candle',
  miracle_dye = 'miracle_dye',
  hero_xp_boost = 'hero_xp_boost',
  bag = 'bag',
  light = 'light',
  med = 'med',
  heavy = 'heavy',
  ring = 'ring',
  dagger = 'dagger',
  hammer = 'hammer',
  staff = 'staff',
  sword = 'sword',
  book = 'book',
  bow = 'bow',
  shield = 'shield',
  trinket = 'trinket',
}
export type GameItemTypeType = `${GameItemType}`;

export enum GameModeKey {
  GAME_MODE_caverns = 'GAME_MODE_caverns',
  GAME_MODE_pvpAuto = 'GAME_MODE_pvpAuto',
  GAME_MODE_pvpLive = 'GAME_MODE_pvpLive',
}
export type GameModeKeyType = `${GameModeKey}`;

export enum HeroHandle {
  assassin = 'assassin',
  battle_mage = 'battle_mage',
  dreamsmith = 'dreamsmith',
  invoker = 'invoker',
  knight = 'knight',
  mercenary = 'mercenary',
  monk = 'monk',
  paladin = 'paladin',
  ranger = 'ranger',
  shaman = 'shaman',
  warlock = 'warlock',
}
export type HeroHandleType = `${HeroHandle}`;

export enum PremiumPurchaseStatus {
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
}
export type PremiumPurchaseStatusType = `${PremiumPurchaseStatus}`;

export enum PrimaryAttribute {
  dexterity = 'dexterity',
  learning = 'learning',
  mana = 'mana',
  perception = 'perception',
  strength = 'strength',
  toughness = 'toughness',
  willpower = 'willpower',
}
export type PrimaryAttributeType = `${PrimaryAttribute}`;

export enum PvPSubmodeKey {
  GAME_SUBMODE_pvp1v1 = 'GAME_SUBMODE_pvp1v1',
  GAME_SUBMODE_pvp2v2 = 'GAME_SUBMODE_pvp2v2',
  GAME_SUBMODE_pvp3v3 = 'GAME_SUBMODE_pvp3v3',
  GAME_SUBMODE_pvp5v5 = 'GAME_SUBMODE_pvp5v5',
  GAME_SUBMODE_pvp7v7 = 'GAME_SUBMODE_pvp7v7',
  GAME_SUBMODE_pvp11v11 = 'GAME_SUBMODE_pvp11v11',
}
export type PvPSubmodeKeyType = `${PvPSubmodeKey}`;

export enum ReferralCodeStatus {
  PENDING = 'PENDING',
}
export type ReferralCodeStatusType = `${ReferralCodeStatus}`;
